// extracted by mini-css-extract-plugin
export var layoutContainer = "_du-0";
export var layoutContainerNoRounding = "_du-6";
export var layoutContainerOpen = "_du-5";
export var layoutContainerResizing = "_du-1";
export var mainContent = "_du-2";
export var resizeDivider = "_du-3";
export var slidePanel = "_du-4";